import { render, staticRenderFns } from "./CompanyRoomStayBinding.vue?vue&type=template&id=2500fb03&"
import script from "./CompanyRoomStayBinding.vue?vue&type=script&lang=js&"
export * from "./CompanyRoomStayBinding.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRoomStayBinding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports